angular
    .module('resourceCenterMaterialModule')
    .directive('materialCheckErrorMsg', ['mrApiService', '$sessionStorage', 'modalDialog', '$interval', function(mrApiService, $sessionStorage, modalDialog, $interval) {
        return {
            scope: {
                resourceId: '=',
                resourceType: '=',
                relationId: '=',
                mrType: '=',
                resourceStatus: '=', // 历史命名问题，指令实际使用时请传入checkstatus的值
                onIgnore: '&',
                errorData: '=',
                direction: '=',
                mediaName: '=',
                isShowSuccess: '=',
            },
            restrict: 'E',
            templateUrl: './resourceCenter/materialResource/directive/checkErrorMsg/checkErrorMsg_tpl.html',
            replace: true,
            link: function(scope, element, attr) {
                initStatus();
                initData();

                /**
                 * [initStatus 初始化状态]
                 *
                 * @return  {[type]}  [return description]
                 */
                function initStatus() {
                    scope.status = {
                        isShowErrors: false, // 是否显示错误信息
                        isShowErrorBox: false, // 是否显示包括状态图标在内的整个指令
                        isShowErrorMsg: false, // 是否显示错误信息浮窗
                        isLoading: false, // 是否出于请求模式
                    };
                    scope.data = {
                        audidingErrors: [],
                        timer: null,
                    };
                }

                /**
                 * [initData 初始化数据]
                 *
                 * @return  {[type]}  [return description]
                 */
                function initData() {
                    isShowErrorBox();
                    startWatchStatus();
                }

                /**
                 * [startWatchStatus 开始循环监控素材三鉴状态]
                 *
                 * @return  {[type]}  [return description]
                 */
                function startWatchStatus() {
                    if (scope.resourceStatus === 0) {
                        startInterval();
                    } else {
                        if (scope.resourceStatus === 1) {
                            afterSuccess(true);
                        }
                    }
                }

                /**
                 * [getErrorMsg 获取错误信息]
                 *
                 * @return  {[type]}  [return description]
                 */
                function isShowErrorBox() {
                    if (scope.relationId) {
                        scope.status.isShowErrorBox = true;
                    }
                }

                /**
                 * [startInterval 开启定时查询三鉴状态]
                 *
                 * @return  {[type]}  [return description]
                 */
                function startInterval() {
                    if (!scope.relationId) {
                        return;
                    }
                    let checkDetailGapTime = 5000;
                    scope.data.timer = $interval(function() {
                        let params = {
                            relationId: scope.relationId,
                            mrType: scope.mrType,
                            mainResourceType: scope.resourceType,
                        };
                        mrApiService.getMaterialDetail(params).then(function(data) {
                            if (data.datas[0] && data.datas[0].checkStatus !== 0) {
                                $interval.cancel(scope.data.timer);
                                scope.resourceStatus = data.datas[0].checkStatus;
                                if (data.datas[0].checkStatus === 1) {
                                    scope.isShowSuccess = true;
                                    setTimeout(() => {
                                        scope.isShowSuccess = false;
                                    }, 3000);
                                    afterSuccess();
                                }
                            }
                        });
                    }, checkDetailGapTime);

                }

                /**
                 * [ignoreError 忽略错误信息]
                 *
                 * @return  {[type]}  [return description]
                 */
                scope.ignoreError = function() {
                    let params = {
                        mrType: scope.mrType,
                        relationId: scope.relationId,
                        mainResourceType: scope.resourceType,
                        mediaName: scope.mediaName,
                    };
                    scope.status.isLoading = true;
                    scope.loadingPromise = mrApiService.ignoreError(params).then(function(data) {
                        scope.status.isLoading = false;
                        if (data.code === '200') {
                            modalDialog.alertType('成功', data.datas.message, 'success', false, function() {
                                scope.resourceStatus = 1;
                                afterSuccess(true);
                            });

                        } else {
                            modalDialog.alertType('错误', '忽略失败');
                        }
                    }, function(data) {
                        modalDialog.alertType('错误', '请求出错');
                    });
                };

                /**
                 * [afterSuccess 成功之后的处理]
                 *
                 * @param   {[type]}  isCallback  [isCallback description]
                 *
                 * @return  {[type]}              [return description]
                 */
                function afterSuccess(isCallback) {
                    if (isCallback) {
                        scope.onIgnore && scope.onIgnore();
                    }
                }

                /**
                 * [showMsg 显示错误信息]
                 *
                 * @return  {[type]}  [return description]
                 */
                scope.showMsg = function() {
                    if (scope.errorData) {
                        scope.status.isShowErrorMsg = true;
                        scope.status.isShowErrors = true;

                    } else {
                        let param = {
                            resourceid: scope.resourceId,
                            tenantId: $sessionStorage.get('curUserInfo').TENANTID,
                            userName: $sessionStorage.get('curUserInfo').USERNAME,
                        };
                        scope.loadingPromise = mrApiService.getErrorMsg(param).then(function(data) {
                            if (data.code === '200') {
                                scope.errorData = data.datas;
                                scope.status.isShowErrorMsg = true;
                                scope.status.isShowErrors = true;
                            }
                        });
                    }
                };

                /**
                 * [hideMsg 隐藏错误信息浮窗]
                 *
                 * @return  {[type]}  [return description]
                 */
                scope.hideMsg = function() {
                    if (scope.status.isLoading) {
                        return;
                    }
                    scope.status.isShowErrorMsg = false;
                };

                scope.$watch('resourceStatus', function(newV, oldV) {
                    // isShowErrorBox();
                    if (oldV === 1 && newV === 0) {
                        startWatchStatus();
                    }
                });

            },
        };
    }]);
